import { defineComponent } from 'vue';
import FilterIndikatorGroupUniversal from '@/components/Blue/ProductListing/FilterIndikatorGroupUniversal.vue';
import FilterIndikatorGroupPriceRange from '@/components/Blue/ProductListing/FilterIndikatorGroupPriceRange.vue';
import { BlueFilterType } from '@/enums/BlueFilterType';
export default defineComponent({
    name: 'filter-indicators-all',
    computed: {
        BlueFilterType() {
            return BlueFilterType;
        },
    },
    components: {
        FilterIndikatorGroupPriceRange,
        FilterIndikatorGroupUniversal,
    },
});
